import { CardType } from "core/types";
import { content, date } from "core/utils";
export function cardToContentCollectionCard(card) {
    var _a, _b, _c;
    switch (card.__typename) {
        case CardType.Video:
            return {
                kind: "Video",
                uuid: card.uuid,
                description: card.description,
                type: card.type,
                caption: card.program ? card.program.title : null,
                title: card.title,
                image: card.image,
                program: card.program ? card.program : null,
                duration: date.getDigitalMinSec(card.duration * 1000),
                slug: card.slug,
            };
        case CardType.Article:
        case CardType.BasicPage:
            return {
                kind: "Basic",
                uuid: card.uuid,
                description: card.description,
                type: card.type,
                caption: card.program ? card.program.title : null,
                title: card.title,
                image: card.image,
                program: card.program ? card.program : null,
                slug: card.slug,
                openInNewTab: ((_a = card.embed) === null || _a === void 0 ? void 0 : _a.displayMode) === "Fullscreen",
            };
        case CardType.Contest:
        case CardType.Interactive:
        case CardType.Participate:
            return {
                kind: "Labeled",
                description: card.description,
                uuid: card.uuid,
                type: card.type,
                caption: card.program ? card.program.title : null,
                title: card.title,
                image: card.image,
                program: card.program ? card.program : null,
                slug: card.slug,
                label: card.displayType,
                ctaText: card.ctaTitle,
                openInNewTab: ((_b = card.embed) === null || _b === void 0 ? void 0 : _b.displayMode) === "Fullscreen",
            };
        case CardType.Person:
            return {
                kind: "Person",
                description: card.description,
                uuid: card.uuid,
                type: card.type,
                title: card.title,
                image: card.image,
                caption: card.description,
                isInactive: card.isInactive,
            };
        case CardType.VtmGoEpisode:
            return {
                kind: "VtmGo",
                uuid: card.uuid,
                program: null,
                description: card.description,
                type: CardType.VtmGoEpisode,
                title: card.title,
                image: (_c = card.image) !== null && _c !== void 0 ? _c : undefined,
                caption: card.description,
                isPlusContent: card.isPlusContent,
            };
        case CardType.Ticket:
            return {
                type: CardType.Ticket,
                kind: "Ticket",
                label: card.label,
                uuid: card.uuid,
                title: card.title,
                image: card.image,
                caption: card.program ? card.program.title : null,
                url: card.url,
                program: card.program ? card.program : null,
                ctaText: content.tickets.cta,
            };
        default:
            return {
                kind: "Text",
                text: "component type was not a card",
            };
    }
}
